export default __webpack_public_path__ + "static/media/ev_error.addd33ed.svg";